import { ISessionManager } from 'common/sessions';
import { CookieBackedSessionManager } from './CookieBackedSessionManager';
import { MockSessionManager } from './MockSessionManager';

export const createSessionManager = (): ISessionManager => {
  if (typeof window === 'undefined') {
    return new MockSessionManager();
  }

  return new CookieBackedSessionManager();
};
